/**
 * StatusIcons
 *
 * 15×15 status indicator icons used by the preview-drawer status dropdown
 * (and its read-only badge counterpart). Matches Figma "Account Statuses"
 * component at node 8959:83364 / 3917:38359.
 *
 * Each icon is monochrome via `currentColor` so the container sets the
 * selected vs greyed-out colour.
 */

import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & { className?: string };

const SHARED_SVG_PROPS = {
  width: 15,
  height: 15,
  viewBox: '0 0 14 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
} as const;

export function StatusActiveIcon({ className, ...props }: Props) {
  return (
    <svg {...SHARED_SVG_PROPS} viewBox="0 0 15 15" className={className} {...props}>
      <circle cx="7.5" cy="7.5" r="7.5" fill="currentColor" />
      <path
        d="M10.6543 4.46582C10.8973 4.22305 11.2912 4.22408 11.5342 4.4668C11.7772 4.70985 11.7772 5.10363 11.5342 5.34668L6.24707 10.6338C6.05953 10.821 5.75582 10.8211 5.56836 10.6338L3.46484 8.53027C3.22203 8.28718 3.22196 7.89247 3.46484 7.64941C3.7077 7.4069 4.1016 7.40716 4.34473 7.64941L5.90723 9.20801H5.9082L10.6543 4.46582Z"
        fill="white"
      />
    </svg>
  );
}

export function StatusInactiveIcon({ className, ...props }: Props) {
  return (
    <svg {...SHARED_SVG_PROPS} className={className} {...props}>
      <rect width="14" height="14" rx="7" fill="currentColor" />
      <path d="M4 7H10" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function StatusDraftIcon({ className, ...props }: Props) {
  return (
    <svg {...SHARED_SVG_PROPS} className={className} {...props}>
      <circle
        cx="7"
        cy="7"
        r="6.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray="2.45 2.45"
      />
    </svg>
  );
}

export function StatusCancelledIcon({ className, ...props }: Props) {
  return (
    <svg {...SHARED_SVG_PROPS} viewBox="0 0 15 15" className={className} {...props}>
      <circle cx="7.5" cy="7.5" r="7.5" fill="currentColor" />
      <path
        d="M10.6104 4.38965C10.4009 4.18015 10.061 4.18015 9.85156 4.38965L7.5 6.74121L5.14941 4.38965C4.93996 4.18015 4.60008 4.18015 4.39062 4.38965C4.18156 4.59911 4.18131 4.93902 4.39062 5.14844L6.74121 7.49902L4.38965 9.85254C4.18042 10.0619 4.18067 10.4009 4.38965 10.6104C4.59913 10.8194 4.93913 10.8197 5.14844 10.6104L7.5 8.25879L9.85254 10.6113C10.062 10.8204 10.402 10.8204 10.6113 10.6113C10.8206 10.402 10.8203 10.0621 10.6113 9.85254L8.25879 7.49902L10.6104 5.14844C10.8196 4.93914 10.8191 4.59916 10.6104 4.38965Z"
        fill="white"
      />
    </svg>
  );
}
